"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoteBaseExtension = exports.NoteKind = exports.name = void 0;
const core_1 = require("@tiptap/core");
const nodes_1 = require("../nodes");
exports.name = 'note';
var NoteKind;
(function (NoteKind) {
    NoteKind["Neutral"] = "neutral";
    NoteKind["Dangerous"] = "dangerous";
    NoteKind["DangerousLight"] = "dangerous-light";
    NoteKind["Warning"] = "warning";
    NoteKind["WarningLight"] = "warning-light";
    NoteKind["Positive"] = "positive";
    NoteKind["PositiveLight"] = "positive-light";
    NoteKind["Primary"] = "primary";
    NoteKind["PrimaryLight"] = "primary-light";
})(NoteKind || (exports.NoteKind = NoteKind = {}));
exports.NoteBaseExtension = core_1.Mark.create({
    name: exports.name,
    parseHTML() {
        return [
            {
                tag: `span[data-mark="${exports.name}"]`
            }
        ];
    },
    renderHTML({ HTMLAttributes, mark }) {
        return [
            'span',
            { ...HTMLAttributes, 'data-mark': this.name, class: `theme-text-editor-note-anchor ${mark.attrs.kind}` },
            0
        ];
    },
    addAttributes() {
        return {
            title: {
                default: null
            },
            kind: (0, nodes_1.getDataAttribute)('kind', { default: NoteKind.Neutral })
        };
    }
});
//# sourceMappingURL=noteBase.js.map